import React from 'react';
import { importFromS3 } from '../../utils/importFromS3';

const AskFieldviewWebPlugin = React.lazy(() => importFromS3('ask-fieldview-web'));

export const AskFieldviewWebPluginContainer: React.FC = () => (
  <AskFieldviewWebPlugin />
);
